module.exports = __webpack_public_path__ + "img/button_top.24fcf42d.png";